<template>
    <pop
        class="chime-dialog"
        popMaskClass="chime-dialog-mask"
        customClass="save-search-dialog"
        closeClass="close"
        closeIcon="icon-close"
        :allowClose="true"
    >
        <h2 :class="{ 'title-uppercase': isTitleUppercase }">
            {{ $t('md-search-bar.saveThisSearch') }}
        </h2>
        <label>{{ $t('md-search-bar.nameThisSearch') }}</label>
        <input v-model="searchName" @keyup.enter="handleSave" />
        <p class="btn" @click="handleSave">{{ $t('md-search-bar.ok') }}</p>
    </pop>
</template>

<script>
import util from '@/common/util';
export default {
    emits: ['handleSave'],
    i18next: {
        ns: 'md-search-bar'
    },
    name: 'Dialog',
    props: {
        isTitleUppercase: {
            type: Boolean,
            default: () => false
        }
    },
    data: function() {
        return {
            searchName: ''
        };
    },
    methods: {
        handleSave() {
            if (this.searchName.trim()) {
                this.$emit('handleSave', this.searchName.trim());
                this.destroy();
            } else {
                util.toast(this.$t('md-search-bar.pleaseFillInThisForm'));
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../theme/mixin.scss';
.chime-dialog .pop.save-search-dialog {
    width: 375px;
    min-height: 50px;
    background: white;
    padding: 70px 50px 60px;
    h2 {
        font-size: 24px;
        font-weight: normal;
        font-family: var(--font-medium);
        line-height: 26px;
        margin-bottom: 25px;
        color: #202437;
        text-align: center;
        &.title-uppercase {
            text-transform: uppercase;
        }
    }
    label {
        font-size: 14px;
        line-height: 15px;
    }
    input {
        border: solid 1px #ebecf1;
        width: 100%;
        height: 40px;
        line-height: 16px;
        padding: 0 15px;
        font-size: 14px;
        margin-top: 10px;
        color: #202437;
    }
    .btn {
        font-family: var(--font-medium);
        font-size: 14px;
        margin-top: 20px;
        width: 100%;
        height: 40px;
        line-height: 40px;
        color: #ffffff;
        text-align: center;
        @include color-theme('background-color');
        @include color-theme('box-shadow', 0 2px 16px -3px);
        cursor: pointer;
    }
}
.fr-CA .chime-dialog .pop.save-search-dialog {
    width: 425px;
    max-width: 100vw;
}
</style>
